import './Disclaimer.css'

const disclaimer = () => {
  return (
    <div className='disclaimer_main'>
    <span className='disclaimer_title'> Disclaimer</span>
    <div className='disclaimerDiv'>
        <p>
        Investments in securities are subject to market risks. Please read all related documents carefully before investing. The information provided is based on statistical and AI models, which are never error-free. 
        You are advised to exercise your own discretions, when using this information. Registration granted by SEBI and certification from NISM 
        in no way guarantee the performance of the intermediary or assure returns to investors.
        </p>
    </div>
</div>
  )
}

export default disclaimer
